<template>
    <activation-deliverables-provider
        v-slot="{ brief, task, isLoading, errors, errorMessage, onPageClose, deliverables, onBack }"
        style="height: 100%"
    >
        <activation-deliverables-view
            :brief="brief"
            :task="task"
            :is-loading="isLoading"
            :errors="errors"
            :error-message="errorMessage"
            :deliverables="deliverables"
            @close="onPageClose"
            @back="onBack"
        />
    </activation-deliverables-provider>
</template>

<script>
    import ActivationDeliverablesProvider from '../providers/activation-brief-steps/ActivationDeliverablesProvider.vue';
    import ActivationDeliverablesView from '../data-views/activation-briefs/ActivationDeliverablesView.vue';

    export default {
        name: 'ActivationDeliverablesRouterView',
        components: {
            ActivationDeliverablesProvider,
            ActivationDeliverablesView
        }
    };
</script>
